export function randomString(length) {
  const a = new Uint8Array(length);
  window.crypto.getRandomValues(a);

  return btoa(String.fromCharCode.apply(null, a)).replace("/", "_");
}
